import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconHome: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconHome"><Path fillRule="evenodd" clipRule="evenodd" d="M12 1.21155L21 8.52405V21H3V8.52405L12 1.21155Z" fill="currentColor"/></CentralIconBase>;
});

export default IconHome;
